import React from 'react';

function UserList({ users = [], isOpen, onToggle }) {
  // Format time
  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const diff = Date.now() - timestamp;
    const minutes = Math.floor(diff / 60000);
    
    if (minutes < 1) return 'now';
    if (minutes < 60) return `${minutes}m`;
    
    const hours = Math.floor(minutes / 60);
    return `${hours}h`;
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'ONLINE': return '#4ade80';        // سبز
      case 'DISCONNECTED': return '#ef4444';  // قرمز
      default: return '#666';
    }
  };
  
  const getStatusText = (status) => {
    switch (status) {
      case 'ONLINE': return 'Online';
      case 'DISCONNECTED': return 'Offline';
      default: return '';
    }
  };

  const onlineCount = users.filter(u => u.status === 'ONLINE').length;

  
  return (
    <div className="user-list-panel" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <div className="user-list-panel-header" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.75rem 1rem',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        flexShrink: 0,
      }}>
        <h3 className="user-list-panel-title" style={{ 
          fontSize: '0.85rem', 
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          margin: 0,
        }}>
          👥 Online
          <span className="user-list-count" style={{
            background: 'rgba(102,126,234,0.2)',
            color: '#667eea',
            fontSize: '0.7rem',
            padding: '2px 7px',
            borderRadius: '10px',
            fontWeight: 700,
          }}>
            {onlineCount}
          </span>
        </h3>
        <button 
          className="user-list-close-btn" 
          onClick={onToggle}
          style={{
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            opacity: 0.4,
            fontSize: '0.9rem',
            padding: '4px 6px',
            borderRadius: '4px',
          }}
          title="Close"
        >
          ✕
        </button>
      </div>
      
      {/* Body */}
      <div className="user-list-panel-body" style={{
        flex: 1,
        overflowY: 'auto',
        padding: '0.5rem',
      }}>
        {(!users || users.length === 0) ? (
          <div className="user-list-empty" style={{
            textAlign: 'center',
            padding: '2rem 1rem',
            opacity: 0.4,
          }}>
            <span className="empty-icon" style={{ fontSize: '2rem', display: 'block', marginBottom: '0.5rem' }}>👤</span>
            <p style={{ fontSize: '0.8rem', margin: 0 }}>No users</p>
          </div>
        ) : (
          users.map((user, i) => {
            const statusColor = getStatusColor(user.status);
            const statusText = getStatusText(user.status);
            
            return (
              <div 
                key={user.sessionId || i} 
                className="user-list-item"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.65rem',
                  padding: '0.5rem 0.6rem',
                  borderRadius: '8px',
                  transition: 'background 0.15s',
                  opacity: user.status === 'DISCONNECTED' ? 0.5 : 1,
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(102,126,234,0.08)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                {/* Avatar */}
                <div style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: '0.75rem',
                  flexShrink: 0,
                  position: 'relative',
                }}>
                  {(user.username || 'A').charAt(0).toUpperCase()}
                  {/* Status dot */}
                  <span style={{
                    position: 'absolute',
                    bottom: '-1px',
                    right: '-1px',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: statusColor,
                    border: '2px solid #1a1a2e',
                  }}></span>
                </div>
                
                {/* Info */}
                <div style={{
                  flex: 1,
                  minWidth: 0,
                  display: 'flex',
                  flexDirection: 'column',
                }}>
                  <span style={{
                    fontSize: '0.8rem',
                    fontWeight: 500,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}>
                    {user.username || 'Anonymous'}
                  </span>
                  <span style={{
                    fontSize: '0.65rem',
                    color: statusColor,
                    opacity: 0.8,
                  }}>
                    {statusText}
                  </span>
                </div>
                
                {/* Time */}
                <span style={{
                  fontSize: '0.65rem',
                  opacity: 0.35,
                  flexShrink: 0,
                }}>
                  {user.status === 'DISCONNECTED' ? '⏳' : formatTime(user.joinedAt)}
                </span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default UserList;